// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jfWCM","index":"styles_index__5zdrm"};